import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from "@material-ui/core";
import classNames from "classnames";
import { memo } from "react";

import {
  generateClasses,
  OptionalBreakpointValues,
} from "../../utilities/functions";

import styles from "./Button.module.scss";

type ButtonProps = MuiButtonProps & {
  readonly spacingTop?: number | OptionalBreakpointValues;
  readonly spacingRight?: number | OptionalBreakpointValues;
};

export const Button = memo<ButtonProps>(
  ({ className, spacingTop, spacingRight, ...restProps }) => {
    const additionalStyles = generateClasses({
      spacingTop,
      spacingRight,
    });

    const classes = classNames(...additionalStyles, className, styles.button);

    return <MuiButton className={classes} {...restProps} />;
  }
);
